export const KeyboardArrowDown = "ArrowDown"
export const KeyboardArrowLeft = "ArrowLeft"
export const KeyboardArrowRight = "ArrowRight"
export const KeyboardArrowUp = "ArrowUp"
export const KeyboardEnd = "End"
export const KeyboardHome = "Home"
